import React, { Component } from 'react';
import { connect } from 'react-redux';
import DetailPolicyList from './DetailPolicyList';

class DetailGroupList extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    let result = false;
    const { sikGroup, sikPolicy } = this.props;
    const { sikGroup: nSikGroup, sikPolicy: nSikPolicy} = nextProps;
    if (sikGroup && (nSikPolicy && nSikPolicy.length)) {
      const { group } = sikGroup.data;
      if (group.length === nSikPolicy.length) {
        result = true;
      }
    }
    return result;
  }
  componentDidUpdate() {
    $(".column.right .master").prop("checked", true);
  }
  render() {
    const { sikGroup, groupSel, policySel, sikPolicy } = this.props;
    const style = {
      width: "150px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    }
    let policy = null;
    return (
      <div>
        {
          sikGroup && sikGroup.data ?
          (
            sikGroup.data.group.map((item, index) => {
                let policy = null;
                if (sikPolicy && sikPolicy.length > 0) {
                  sikPolicy.some((pItem) => {
                    if (pItem.key === `group${item.idx}`){
                      policy = pItem.policy;
                      return true;
                    }
                  });
                }
              return(
                <ul key={item.idx} className={"group mg16 g_"+item.idx}>
                  <li>
                    <div className='checkbox pure' style={style}>
                      <label>
                        <input
                          type='checkbox'
                          id={item.idx}
                          className='master'
                          onChange={groupSel}/>
                        <span></span>
                        {item.name}
                      </label>
                    </div>
                  </li>
                  <li>
                    <DetailPolicyList
                      groupIdx={item.idx}
                      style={style}
                      policies={policy}
                      policySel={policySel}
                    />
                  </li>
                </ul>
              )
            })
          ) : null
        }
      </div>
    )
  }
};

DetailGroupList = connect(
  state => ({
    sikGroup: state.commons.sikdaeGroup,
    sikPolicy: state.commons.sikdaePolicyArray
  }),
  dispatch => ({
  })
)(DetailGroupList);

export default DetailGroupList;